import React from "react";
import SEO from "../components/SEO";
import { LegalPage } from "../components/LegalPage";
import { TERMS_SECTIONS, LEGAL_UPDATED } from "../data/legal";

export default function Terms() {
  return (
    <>
      <SEO title="Terms & Conditions" description="Terms for booking and using Cambridge Cardiovascular Prevention Clinic: fees, payment, cancellations and refunds, and use of the website." path="/terms" />
      <LegalPage testId="terms-page" eyebrow="Terms & conditions" title="Booking and website terms." updated={LEGAL_UPDATED} sections={TERMS_SECTIONS} />
    </>
  );
}
